<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>消息中心</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Title" label="标题"></el-table-column>
          <el-table-column prop="Message" label="消息"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间"></el-table-column>
        </el-table>
        <!-- 数据列表 end -->
        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="5"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="添加" name="second" v-if="SubRule_MessageCenter_Add">
      <el-form :model="addForm" ref="addFormRef" label-width="70px">
        <el-form-item label="消息类型" class="addAdminForm">
          <el-select v-model="addForm.messagetype" placeholder="请选择" style="width: 100%">
            <el-option label="指定用户" value="1"></el-option>
            <el-option label="所有用户" value="2"></el-option>
            <el-option label="指定机构" value="3"></el-option>
            <el-option label="指定角色" value="4"></el-option>
            <el-option label="机构和角色组合" value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择用户" class="addAdminForm" v-if="addForm.messagetype == 1">
          <el-input v-model="addForm.erpuserloginname" placeholder="请输入登录账号"></el-input>
          <el-button type="success" plain @click="apicheckerpuser">校验</el-button>
          <li>姓名：{{addForm.erpusername}}</li>
        </el-form-item>
        <el-form-item label="归属机构" class="addAdminForm" v-if="addForm.messagetype == 3 || addForm.messagetype == 5">
          <Rsljigou :propsjigouid="addForm.jigouid" :propsjigouname="addForm.jigouname" @change="changeRsljigou"></Rsljigou>
        </el-form-item>
        <el-form-item label="角色" class="addAdminForm" v-if="addForm.messagetype == 4 || addForm.messagetype == 5">
          <el-select v-model="addForm.roleid" placeholder="请选择" style="width: 100%">
            <el-option
              v-for="item in rolelist" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" class="addAdminForm">
          <el-input v-model="addForm.title"></el-input>
        </el-form-item>
        <el-form-item label="消息" class="addAdminForm">
          <el-input type="textarea" v-model="addForm.message" placeholder="请输入消息" rows="5"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickadd">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

  </el-tabs>
  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou
  },
  name: 'MessageCenter',
  data () {
    return {
      activeName: 'first',
      addForm: {
        messagetype: '1',
        title: '',
        message: '',
        erpuserid: '',
        erpusername: '',
        erpuserloginname: '',
        jigouid: '-1',
        jigouname: '',
        roleid: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      rolelist: [],
      SubRule_MessageCenter_Add: false
    }
  },
  mounted () {
    this.apiGetMessageCenterAllNum()
    this.apiGetMessageCenterAllList()

    this.apigetallrole()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_MessageCenter_Add', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_MessageCenter_Add = true
      }
    })
  },
  methods: {
    changeRsljigou (vid, vname) {
      this.addForm.jigouid = vid
      this.addForm.jigouname = vname
    },
    clickadd () {
      var jigouid = '0'
      var roleid = '0'
      var erpuserid = '0'
      // 指定用户
      if (this.addForm.messagetype === '1') {
        erpuserid = this.addForm.erpuserid
      }
      // 所有用户
      if (this.addForm.messagetype === '2') {
        erpuserid = '-1'
      }
      // 指定机构
      if (this.addForm.messagetype === '3') {
        jigouid = this.addForm.jigouid
      }
      // 指定角色
      if (this.addForm.messagetype === '4') {
        roleid = this.addForm.roleid
      }
      // 机构和角色组合
      if (this.addForm.messagetype === '5') {
        jigouid = this.addForm.jigouid
        roleid = this.addForm.roleid
      }
      this.apiAddMessageCenter(jigouid, roleid, erpuserid)
    },
    clickreturn () {
      this.activeName = 'first'
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetMessageCenterAllList()
    },
    apiGetMessageCenterAllNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetMessageCenterAllNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetMessageCenterAllList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetMessageCenterAllList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddMessageCenter: function (jigouid, roleid, erpuserid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: jigouid,
        roleid: roleid,
        erpuserid: erpuserid,
        title: that.addForm.title,
        message: that.addForm.message
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddMessageCenter, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetMessageCenterAllNum()
            that.apiGetMessageCenterAllList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apicheckerpuser () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        erpuserloginname: that.addForm.erpuserloginname
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_CheckErpuser, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.addForm.erpuserid = response.data.Erpuserid
            that.addForm.erpusername = response.data.Erpusername
            that.addForm.erpuserloginname = response.data.Erpuserloginname
          } else {
            that.addForm.erpuserid = ''
            that.addForm.erpusername = ''
            that.addForm.erpuserloginname = ''
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigetallrole: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getallrole, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.rolelist = []
            response.data.List.filter((item1, i1) => {
              that.rolelist.push({ value: item1.Id, label: item1.Name })
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
